import SearchSection from "@/components/SearchSection";
import Layout from "@/components/Layout";
import logo from "@/assets/logo.webp";

const Index = () => {
  return (
    <Layout>
      <section className="max-w-5xl mx-auto mb-6 md:mb-16">
        <div className="flex flex-col items-center justify-center text-center gap-2 md:gap-4 mb-4 md:mb-6">
          <img
            src={logo}
            alt="PartXplorer Logo"
            className="w-16 md:w-32 h-auto mb-1 md:mb-2 animate-fade-in [filter:brightness(0)_saturate(100%)_invert(48%)_sepia(100%)_saturate(3000%)_hue-rotate(200deg)_brightness(102%)_contrast(101%)]"
          />
          <h1 className="text-3xl md:text-7xl font-bold bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent tracking-tight">
            PARTXPLORER
          </h1>

          <div className="space-y-1 md:space-y-2">
            <p className="text-base md:text-2xl text-primary font-semibold">
              La bonne pièce, au bon prix, en un clic !
            </p>
            <p className="text-xs md:text-base text-muted-foreground font-light">
              Comparez instantanément les prix sur 5+ sites de pièces auto
            </p>
          </div>
        </div>
      </section>

      <SearchSection />
    </Layout>
  );
};

export default Index;
